import React, { useEffect, useMemo, useState } from 'react';
import { Box, Typography, Checkbox } from '@material-ui/core';
import style from './style.module.css';
import ActionButton from 'design-v2/common/ActionButton';
import { useSelector } from 'react-redux';
import { DiaryRootState } from 'appRoot/rootReducer';
import { APP_COLORS, Colors } from 'design-v2/globals/colors/colors';
import classNames from 'classnames';


export default function NewBlockoutBySection({ exit, handleSaveClick }: { exit: () => void, handleSaveClick?: (selectedSections: string[]) => void }) {
  const [selectedSections, setSelectedSections] = useState<string[]>([]);

  const currentSections = useSelector((state: DiaryRootState) => state.sectionReducer.currentSections);
  const filteredSections = useMemo(() => {
    return currentSections.filter((section) => !!section.sectionIds && section.sectionIds.length === 1);
  }, [currentSections]);
  const isWideVersion = useSelector((state: DiaryRootState) => state.bookingCreatorSettingReducer.isWideVersion);

  const handleSave = () => {
    handleSaveClick && handleSaveClick(selectedSections);
  };

  const ableToSave = Boolean(selectedSections.length);

  const handleOnCheck = (id: string) => {
    if (selectedSections.includes(id)) {
      setSelectedSections(selectedSections.filter((sectionId) => sectionId !== id));
    } else {
      setSelectedSections([...selectedSections, id]);
    }
  }
  const handleOnAllCheck = () => {
    if (selectedSections.length === filteredSections.length) {
      setSelectedSections([]);
    } else {
      setSelectedSections(filteredSections.map((section) => section.sectionIds[0]));
    }
  }

  return (
    <div className={classNames({
      [style.containerBlockout]: !isWideVersion,
      [style.containerBlockoutWideVersion]: isWideVersion,
    })}>
      <div className={style.spaceOutside}>
        <div className={style.header}>
          <div className={style.btnWrap}>
            <ActionButton
              fullWidth={true}
              variant={'secondary'}
              size={'regular'}
              text={'Cancel'}
              handleClick={exit}
            />
          </div>
          <span className={style.title}>New Blockout</span>
          <div>
            <ActionButton
              fullWidth={true}
              variant={'primary'}
              size={'regular'}
              text={'Next'}
              disabled={!ableToSave}
              handleClick={handleSave}
              data-testid={`save-blockoout`}
            />
          </div>
        </div>
      </div>
      <div className={style.containerNew}>
        <Box height={24} />
        <Box display="flex" style={{ gap: 8, marginTop: 12, marginBottom: 8 }}>
          <Typography color="textPrimary">Select one or more sections to block out</Typography>
        </Box>
        <Box
          onClick={handleOnAllCheck}
          alignItems="center"
          display="flex"
          style={{
            marginTop: 12,
            borderBottom: `1px solid ${Colors.get(APP_COLORS.clrGreyLight)}`,
          }}
        >
          <Checkbox
            checked={selectedSections.length === filteredSections.length}
            onChange={handleOnAllCheck}
            color="primary"
            data-testid={`select-blockout-section-all`}
          />
          <Typography
            style={{ marginRight: 12, marginLeft: 12, width: '30%' }}
            className={style.ellipsis}
            color={'textPrimary'}
          >
            {'All sections'}
          </Typography>
        </Box>
        {filteredSections.map((section, index) => {
          const isLast = index === currentSections.length - 1;
          const isSelected = selectedSections.includes(section.sectionIds[0]);
          return (
            <Box
              onClick={() => handleOnCheck(section.sectionIds[0])}
              alignItems="center"
              key={index}
              display="flex"
              style={{
                marginTop: 12,
                borderBottom: isLast
                  ? 'none'
                  : `1px solid ${Colors.get(APP_COLORS.clrGreyLight)}`,
              }}
            >
              <Checkbox
                checked={isSelected}
                onChange={() => handleOnCheck(section.sectionIds[0])}
                color="primary"
                data-testid={`select-blockout-section-${index}`}
              />
              <Typography
                style={{ marginRight: 12, marginLeft: 12, width: '30%' }}
                className={style.ellipsis}
                color={'textPrimary'}
              >
                {section.name}
              </Typography>
            </Box>
          );
        })}
      </div>
    </div>
  );
}
